import EfImg from '@elem/ui/ef-img';
import { useProductStore } from '@elem/compPage/12v-lithium-battery/ProductProvider';
import { getIsMobileWidth } from '@elem/utils/devices';
import { useEffect, useRef, useState } from 'react';
import Banner from '../comps/Banner';
import HighlightsA from '../comps/HighlightsA';
import ListA from '../comps/ListA';
import ListB from '../comps/ListB';
import ListC from '../comps/ListC';
import ListD from '../comps/ListD';
import OtherA from '../comps/OtherA';
import OtherB from '../comps/OtherB';
import OtherC from '../comps/OtherC';
import AniStickyA from '../comps/AniStickyA';
import AniStickyB from '../comps/AniStickyB';
import SectionD from '../comps/SectionD';
import SectionLRList from '../comps/SectionLRList';
import TabA from '../comps/TabA';
import { PAGE_TYPE } from '../constants';
import { IPageStatus } from '../config/IPageStatus';
import styles from './ProductContent.module.scss';
import { useRouter } from 'next/router';

export const PRODUCT_BASE = 'https://websiteoss.ecoflow.com/upload/image/1725595196999/%E7%99%BD%E5%BA%95%E5%9B%BE_%E5%9F%BA%E7%A1%80.png';
export const PRODUCT_TM = 'https://websiteoss.ecoflow.com/upload/image/1725595196761/%E7%99%BD%E5%BA%95%E5%9B%BE_TM.png';
export const PRODUCT_OTHER = 'https://websiteoss.ecoflow.com/upload/image/1725604441004/Lead-acid%2012V%20Battery.png';

export default function Teaser() {
    const { pageType, pageStatus } = useProductStore();
    const domRef = useRef();
    const [height, setHight] = useState(0);
    const { locale = 'us' } = useRouter();
    const BG_MAP: any = {
        [PAGE_TYPE.BASE]: {
            // 1858 / 968
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725961846618/pc_bg.jpg',
            // 1126 / 968
            pad: 'https://websiteoss.ecoflow.com/upload/image/1725961838492/m_bg.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725961838492/m_bg.jpg',
        },
        [PAGE_TYPE.MOTOR]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725592097585/pc_bg.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1725592356028/m_bg.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725592356028/m_bg.jpg',
        },
    };
    const bg = BG_MAP[pageType];
    const isMobile = getIsMobileWidth();

    useEffect(() => {
        if (isMobile) {
            let h = document.querySelector('.buy-content-12v')?.offsetHeight;
            if (pageStatus === IPageStatus.statusB) {
                h = h / 2;
            }
            setHight(h);
        }
    }, []);

    return (
        <div className={styles.teaser}>
            <Banner />
            <div className="bg-content">
                <EfImg height={height} className={`bg ${pageType == PAGE_TYPE.BASE ? 'white' : 'black'}`} pc={bg.pc} pad={bg.pad} h5={bg.h5} />
                <HighlightsA />
                <ListA PRODUCT_BASE={PRODUCT_BASE} PRODUCT_TM={PRODUCT_TM} ref={domRef} />
            </div>
            <OtherA />
            {pageType == PAGE_TYPE.BASE && <SectionD />}
            <TabA />
            <AniStickyA />
            {!isMobile && <AniStickyB />}
            {isMobile && <SectionLRList />}
            {pageType == PAGE_TYPE.MOTOR && <SectionD />}
            <ListD />
            <OtherB PRODUCT_OTHER={PRODUCT_OTHER} PRODUCT_TM={PRODUCT_TM} />
            <OtherC />
            {!['br'].includes(locale) && <ListB />}
            <ListC />
        </div>
    );
}
